<div class="container">
  <div class="left">
    <app-photo-and-details></app-photo-and-details>
  </div>

  <div class="right">
    <mat-accordion>
      <mat-expansion-panel *appHasFeature="features.TAB_PERSONAL_DETAILS" togglePosition="before">
          <mat-expansion-panel-header>
            <h4>{{ 'PersonalDetails' | translate: {Default: "Personal Details"} }}</h4>
          </mat-expansion-panel-header>
        
          <ng-template matExpansionPanelContent>
            <app-personal-details-form [employeeId]="user$.userId" [showTitle]="false"></app-personal-details-form>
          </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel *appHasFeature="features.TAB_EMERGENCY_CONTACTS" togglePosition="before">
          <mat-expansion-panel-header>
            <h4>{{ 'EmergencyContacts' | translate: {Default: "Emergency Contacts"} }}</h4>
          </mat-expansion-panel-header>
        
          <ng-template matExpansionPanelContent>
            <app-emergency-contacts [employeeID]="user$.userId" [showTitle]="false"></app-emergency-contacts>
          </ng-template>
      </mat-expansion-panel>

      <mat-expansion-panel *appHasFeature="features.TAB_FAMILY_DEPENDANTS" togglePosition="before">
        <mat-expansion-panel-header>
          <h4>{{ 'FamilyDependants' | translate: {Default: "Family Dependants"} }}</h4>
        </mat-expansion-panel-header>
      
        <ng-template matExpansionPanelContent>
          <app-employee-family-dependants [employeeID]="user$.userId" [showTitle]="false"></app-employee-family-dependants>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>